import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../../Base/Components/BaseModal/BaseModal';
import ManagerHookUpInsuranceBatchInvoice from './ManagerHookUpInsuranceBatchInvoice';

interface Props extends BaseModalProps {
	onSubmit: () => void;
}

const ManagerHookUpInsuranceBatchInvoiceModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.hookUp.insuranceBatchInvoice.connection'>
			<ManagerHookUpInsuranceBatchInvoice onSubmit={props.onSubmit} />
		</BaseModal>
	);
};

export default ManagerHookUpInsuranceBatchInvoiceModal;
